export const turbineBladeManufacturers = [
  // Gas & Steam Turbine Blade Manufacturers - Major OEMs
  "GE Vernova",
  "Siemens Energy",
  "Mitsubishi Heavy Industries",
  "Mitsubishi Power",
  "Ansaldo Energia",
  "Baker Hughes",
  "Solar Turbines",
  "Rolls-Royce",
  "Collins Aerospace",
  "Pratt & Whitney Canada",

  // Gas & Steam Turbine - Aftermarket & Independent
  "Reliable Turbine Services (RTS)",
  "RMS (Rotating Machinery Services)",
  "Industrial Precision MFG",

  // Wind Turbine Blade Manufacturers - Major OEMs
  "Vestas",
  "Siemens Gamesa",
  "LM Wind Power",
  "Nordex",
  "Enercon",
  "Goldwind",

  // Wind Turbine - Independent Blade Manufacturers
  "TPI Composites",

  // Wind Turbine - Chinese Manufacturers
  "SANY Renewable Energy",
  "Shanghai Electric Wind Power Group",
  "Sinovel",
  "Mingyang Wind Power",
  "Zhejiang Windey",

  // Wind Turbine - Other Regional Manufacturers
  "Suzlon",
  "Inox Wind",
  "Hitachi",
  "UNISON",
].sort();
